module.exports = __webpack_public_path__ + "img/G969.8762f02f.jpg";